import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=1af70530&scoped=true"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"
import style0 from "./SelectUsers.vue?vue&type=style&index=0&id=1af70530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af70530",
  null
  
)

export default component.exports